window._ = require("lodash");

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require("popper.js").default;
    window.$ = window.jQuery = require("jquery");

    //trumowyg for non-admnins
    window.trumbowyg = require("trumbowyg");
    $(".trumbowyg-editor").trumbowyg({
        minimalLinks: true,
        btns: [
            [
                "strong",
                "em",
                "link",
                "h2",
                "h3",
                "p",
                "removeformat",
                "viewHTML",
            ],
        ],
        svgPath: "/assets/svg/trumbowyg-icons.svg",
    });

    // Import TinyMCE for admins (TEMP)
    const tinymce = require("tinymce/tinymce");
    require("tinymce/themes/silver/theme");
    require("tinymce/plugins/link/plugin");
    require("tinymce/plugins/code/plugin");
    require("tinymce/plugins/lists/plugin");
    require("tinymce/plugins/autolink/plugin");
    require("tinymce/plugins/autoresize/plugin");
    require("tinymce/plugins/table/plugin");
    require("tinymce/models/dom/model");
    require("tinymce/icons/default/icons");

    // Make tinymce available globally
    window.tinymce = tinymce;

    // AI Ranger plugin (self-registers via tinymce.PluginManager.add)
    require("./tinymce/plugins/airanger/plugin");

    // Comprehensive emoji removal function
    function removeAllEmojis(text) {
        // More comprehensive regex that catches all emoji patterns
        // Note: Excludes \u00a9 (©), \u00ae (®), and \u2122 (™) as these are legitimate typographic symbols
        return text.replace(
            /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g,
            ""
        );
    }

    // Initialize TinyMCE when DOM is ready
    $(document).ready(function () {
        if (typeof tinymce !== "undefined") {
            tinymce.init({
                selector: ".tinymce-editor",
                menubar: false,
                convert_urls: false,
                plugins: [
                    "link",
                    "code",
                    "lists",
                    "autolink",
                    "autoresize",
                    "table",
                    "airanger",
                ],
                toolbar:
                    "bold italic | link | bullist numlist | table | removeformat | code | airanger",
                contextmenu: "airanger link table",
                // Disable license key manager
                license_key: "gpl",
                // Replaced by the AI Ranger status-bar button
                branding: false,
                // Disable external resource loading
                external_plugins: {},
                // Disable CSS loading since we bundle it
                skin: false,
                content_css: false,
                content_style:
                    'body { font-family: "Open Sans", Arial, sans-serif; } td, th { padding: 0.4rem 0.6rem; }',
                // Enable image pasting
                paste_data_images: false,
                //auto adds https to all links
                link_assume_external_targets: "https",
                table_default_styles: { width: "100%" },
                valid_elements:
                    "p,br,strong/b,em/i,ul,ol,li,a[href|target],img[src|alt|width|height],table[border|cellpadding|cellspacing|style|width],thead,tbody,tr,th[scope|colspan|rowspan],td[colspan|rowspan]",
                paste_preprocess: function (plugin, args) {
                    // Clean pasted content similar to the old Trumbowyg cleanPaste
                    var content = args.content;

                    // Remove classes and styles
                    content = content.replace(/ class="[^"]*"/gi, "");
                    content = content.replace(/ style="[^"]*"/gi, "");

                    // Remove spans
                    //     content = content.replace(/<\/?span[^>]*>/gi, '');

                    // Convert divs to paragraphs
                    content = content.replace(
                        /<div[^>]*>([\s\S]*?)<\/div>/gi,
                        "<p>$1</p>"
                    );

                    // Convert h1-h6 to paragraphs with strong text and ensure line breaks
                    content = content.replace(
                        /<h[1-6][^>]*>([\s\S]*?)<\/h[1-6]>/gi,
                        "<p><strong>$1</strong></p>"
                    );

                    // Remove all emojis from pasted content
                    content = removeAllEmojis(content);

                    setTimeout(function () {
                        $("#paste-formatting-warning").slideDown("fast");
                    }, 100);

                    args.content = content;
                },
                setup: function (editor) {
                    editor.on("init", function () {
                        console.log("TinyMCE editor initialized");
                    });

                    // Prevent emoji input through keypress events
                    editor.on("keypress", function (e) {
                        const char = String.fromCharCode(e.charCode || e.which);
                        if (char !== removeAllEmojis(char)) {
                            e.preventDefault();
                            return false;
                        }
                    });

                    // Clean content on input events (catches IME input, drag & drop, etc.)
                    editor.on("input", function (e) {
                        const content = editor.getContent();
                        const cleanContent = removeAllEmojis(content);
                        if (content !== cleanContent) {
                            editor.setContent(cleanContent);
                        }
                    });

                    // Additional protection for beforeinput event (modern browsers)
                    editor.on("beforeinput", function (e) {
                        if (e.data && e.data !== removeAllEmojis(e.data)) {
                            e.preventDefault();
                            return false;
                        }
                    });
                },
            });
        }
    });

    // Initialize TinyMCE on mail template editor
    $(document).ready(function () {
        if (
            typeof tinymce !== "undefined" &&
            document.querySelector(".mail-template-tinymce")
        ) {
            tinymce.init({
                selector: ".mail-template-tinymce",
                menubar: false,
                convert_urls: false,
                plugins: ["link", "lists", "autolink", "autoresize"],
                toolbar: "bold italic | link | bullist numlist | removeformat",
                license_key: "gpl",
                external_plugins: {},
                skin: false,
                content_css: false,
                content_style:
                    'body { font-family: "Open Sans", Arial, sans-serif; font-size: 14px; }',
                paste_data_images: false,
                link_assume_external_targets: "https",
                valid_elements:
                    "p,br,strong/b,em/i,h2,h3,ul,ol,li,a[href|target]",
                autoresize_min_height: 250,
                autoresize_max_height: 500,
            });

            // Sync TinyMCE content back to textarea before form submit
            $("form").on("submit", function () {
                tinymce.triggerSave();
            });
        }
    });

    // Initialize TinyMCE on email composer when Livewire renders it
    document.addEventListener("livewire:init", function () {
        // Sync TinyMCE when Livewire updates the body (e.g. template change)
        Livewire.on("composerBodyUpdated", (params) => {
            var editor = tinymce.get("email-composer-body");
            if (editor) {
                editor.setContent(params.body || "");
            }
        });

        Livewire.hook("morph.added", ({ el }) => {
            if (el.querySelector && el.querySelector("#email-composer-body")) {
                setTimeout(function () {
                    var existing = tinymce.get("email-composer-body");
                    if (existing) existing.remove();

                    tinymce.init({
                        selector: "#email-composer-body",
                        menubar: false,
                        convert_urls: false,
                        plugins: ["link", "lists", "autolink", "autoresize"],
                        toolbar:
                            "bold italic | link | bullist numlist | removeformat",
                        license_key: "gpl",
                        external_plugins: {},
                        skin: false,
                        content_css: false,
                        content_style:
                            'body { font-family: "Open Sans", Arial, sans-serif; font-size: 14px; }',
                        paste_data_images: false,
                        link_assume_external_targets: "https",
                        valid_elements:
                            "p,br,strong/b,em/i,h2,h3,ul,ol,li,a[href|target]",
                        autoresize_min_height: 200,
                        autoresize_max_height: 400,
                        setup: function (editor) {
                            var debounceTimer;
                            editor.on("input change keyup", function () {
                                clearTimeout(debounceTimer);
                                debounceTimer = setTimeout(function () {
                                    var content = editor.getContent();
                                    var composerEl = document
                                        .getElementById("email-composer-body")
                                        ?.closest("[wire\\:id]");
                                    var component = composerEl
                                        ? Livewire.find(
                                              composerEl.getAttribute("wire:id")
                                          )
                                        : null;
                                    if (component) {
                                        component.set("body", content);
                                        component.call("autosave");
                                    }
                                }, 2000);
                            });
                        },
                    });
                }, 50);
            }
        });
    });

    // Initialize emoji filtering for input fields with 'no-emoji' class
    $(document).ready(function () {
        $(".strip-emojis").on("paste", function (e) {
            const $input = $(this);
            // Small delay to let the paste happen first
            setTimeout(function () {
                const currentValue = $input.val();
                const cleanValue = removeAllEmojis(currentValue);
                if (currentValue !== cleanValue) {
                    $input.val(cleanValue);
                    // Trigger input event to notify any listeners (like autosave)
                    $input.trigger("input");
                }
            }, 10);
        });
    });

    window.select2 = require("select2");
    window.selectize = require("selectize");
    window.DataTable = require("datatables.net-bs4");

    // Initialize any tables with class 'datatable'
    $(".datatable").DataTable({
        ordering: false,
        pageLength: 20,
        layout: {
            topStart: null,
            topEnd: "search",
            bottomStart: null,
            bottomEnd: null,
            bottom: "paging",
        },
    });

    require("bootstrap");
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require("axios");
window.slick = require("slick-carousel");

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });

import "./interface";
import "./interface/autosave";
// import './select-2-tree';
import "./billing";
// Import Ion Rangeslider
import ionRangeSlider from "ion-rangeslider";
window.ionRangeSlider = ionRangeSlider;
import "./front/hs-mask";
import "./front/appear";
import "./front/circles";
import "./front";
// import './front/hs-slick-carousel';
import "./front/hs-header";
import "./front/hs-unfold";
import "./front/hs-show-animation";
import "./front/hs-toggle-switch";
